import React from "react";

const CategoryButton = ({
  selectedCategory,
  name,
  icon,
  setSelectedCategory,
}) => {
  const catergoryBtnClickHandler = () => {
    setSelectedCategory(name);
  };

  return (
    <button
      onClick={catergoryBtnClickHandler}
      className="category-btn"
      style={{
        background: name === selectedCategory && "#FC1503",
        color: "white",
      }}
    >
      <span
        style={{
          color: name === selectedCategory ? "white" : "red",
          marginRight: "15px",
        }}
      >
        {icon}
      </span>
      <span
        style={{
          color: name === selectedCategory ? "white" : "white",
          marginRight: "15px",
        }}
      >
        {name}
      </span>
    </button>
  );
};

export default CategoryButton;
